// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"90":"7650fbcc","289":"11912edf","535":"cc596e18","935":"36d8b304"}[chunkId] + ".chunk.css";
};